import React, { useEffect } from 'react';
import { XMarkIcon, ExclamationTriangleIcon, CheckCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';

const ErrorToast = ({ error, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  // Determine the type of message
  const isSuccess = error.type === 'success' || error.message?.includes('successfully');
  const isInfo = error.type === 'info' || error.message?.includes('Creating') || error.message?.includes('Processing');

  const getStyles = () => {
    if (isSuccess) return 'border-green-500/20 text-green-500';
    if (isInfo) return 'border-blue-500/20 text-blue-500';
    return 'border-red-500/20 text-red-500';
  };

  const Icon = () => {
    if (isSuccess) return <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" />;
    if (isInfo) return <InformationCircleIcon className="w-5 h-5 text-blue-500 flex-shrink-0" />;
    return <ExclamationTriangleIcon className="w-5 h-5 text-red-500 flex-shrink-0" />;
  };

  const getTitle = () => {
    if (isSuccess) return 'Success';
    if (isInfo) return 'Info';
    return 'Error';
  };

  return (
    <div className={`fixed bottom-4 right-4 max-w-sm bg-dark-card rounded-lg shadow-lg border ${getStyles()} animate-slideIn`}>
      <div className="p-4 flex items-start space-x-3">
        <Icon />
        <div className="flex-1">
          <h3 className="text-sm font-medium">
            {getTitle()}
          </h3>
          <p className="mt-1 text-sm text-gray-400">{error.message}</p>
        </div>
        <button
          onClick={onClose}
          className="flex-shrink-0 text-gray-400 hover:text-white transition-colors"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default ErrorToast; 